<template>
	<div class="fd-notice" :class="levelClass" v-if="visible">
		<sym-icon v-if="hasIcon" :name="nt.icon" class="fd-notice-icon"></sym-icon>
		<span class="fd-notice-message">{{ nt.message }}</span>
	</div>
</template>

<script setup lang="ts">
import usePart, {type PartProps, partProps} from "../Part";
import {computed} from "vue";
import SymIcon from "./SymIcon.vue";
import type {Notice} from "@t/fd/fixed/Notice";

const uprops = defineProps({ ...partProps });
const props = uprops as PartProps;

const nt:Notice = props.part as Notice;

const { visible, clazz, style, ro } = usePart(props);

const levelClass = computed(() => {
  if (nt.level) return "fd-notice-" + nt.level.toLowerCase();
  else return "fd-notice-help";
})
const hasIcon = computed(() => {
  return !!nt.icon;
});
</script>

<style></style>
